export default {
  shape:
    '<path fill="#000" fill-opacity=".28" d="m7.33 19.38 1.25-5.33-4.13-3.55 5.43-.47L12 5l2.13 5.03 5.42.47-4.12 3.55 1.25 5.32L12 16.55l-4.67 2.82Z"/>',
  viewBox: [0, 0, 24, 24],
};
